import {IPublishingUser} from "../interfaces/admin/user/publishingUser";
import {IOthersAdmins} from "../interfaces/admin/user/othersAdmins";

export const sortUsers = (users: IPublishingUser[] | IOthersAdmins[]) => {
  return users.sort((a, b) => +a.isActive - +b.isActive || b.id - a.id);
}